import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 28 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "14",
  cy: "14",
  r: "12",
  stroke: "#2BBA69",
  "stroke-width": "3"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#2BBA69",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "m9.5 14 3 3 6-6"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }